import styled from '@emotion/styled';
import React from 'react';
import SEO from '../components/seo';
import { StyledSection } from '../components/_shared/styled-section';
import Form from '../components/form.js';

const StyledSignupSection = styled(StyledSection)`
  height: 100vh;
`;

const StyledForm = styled(Form)`
  padding-top: 2rem;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const JoinPage = () => (
  <StyledSignupSection>
    <SEO title="Sign Up" />
    <StyledForm />
  </StyledSignupSection>
);

export default JoinPage;
